import { IApplicationState } from '../../types/redux';

export function getObjectRating(state: IApplicationState) {
  return state.objectInfo.rating;
}
